import { FeatureFlag } from '../FeatureFlag';

export const enableLabRevenueAnalytics = new FeatureFlag({
    key: 'enable-lab-revenue-analytics',
    defaultValue: false,
});
